// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1aXxk","footer":"ModalInfo_footer__1FdVf"};